import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineAutoTransmissionIcon from 'LuxKit/Icons/line/LineAutoTransmissionIcon'
import LineBoltAltIcon from 'LuxKit/Icons/line/LineBoltAltIcon'
import LineDashboardIcon from 'LuxKit/Icons/line/LineDashboardIcon'
import LineManualTransmissionIcon from 'LuxKit/Icons/line/LineManualTransmissionIcon'
import LinePumpIcon from 'LuxKit/Icons/line/LinePumpIcon'
import LineRefreshIcon from 'LuxKit/Icons/line/LineRefreshIcon'
import LineSuitcaseIcon from 'LuxKit/Icons/line/LineSuitcaseIcon'
import LineUserCircleIcon from 'LuxKit/Icons/line/LineUserCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const QuickIconsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${rem(12)};
  row-gap: ${rem(4)};
`

/* eslint-disable react/jsx-key */
const fuelTypeIconMap = new Map<App.CarHireVehicleFuelType, React.ReactElement>([
  ['Diesel', <LinePumpIcon />],
  ['Electric', <LineBoltAltIcon />],
  ['Hybrid', <LineRefreshIcon />],
  ['Petrol', <LinePumpIcon />],
  ['MultiFuel', <LineRefreshIcon />],
  ['PlugInHybrid', <LineRefreshIcon />],
])

interface Props {
  offer: App.CarHireOffer;
  showMileage: boolean;
}

function CarHireOfferTileVehicleDetailsCondensed(props: Props) {
  const { offer, showMileage } = props

  return <VerticalSpacer gap={4}>
    <QuickIconsContainer>
      <BodyTextBlock variant="medium" startIcon={<LineUserCircleIcon />}>{offer.vehicle.seats}</BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<LineSuitcaseIcon />}>{offer.vehicle.luggage}</BodyTextBlock>
      <BodyTextBlock
        variant="medium"
        startIcon={offer.vehicle.transmission === 'Automatic' ? <LineAutoTransmissionIcon /> : <LineManualTransmissionIcon />}
      >
        {offer.vehicle.transmission === 'Automatic' ? 'Auto' : 'Manual'}
      </BodyTextBlock>
      {offer.vehicle.fuelType !== 'Unspecified' && <BodyTextBlock
        format="titlecase"
        variant="medium"
        startIcon={fuelTypeIconMap.get(offer.vehicle.fuelType)}
      >
        {offer.vehicle.fuelType}
      </BodyTextBlock>}
    </QuickIconsContainer>
    {showMileage &&
      <BodyTextBlock variant="medium" startIcon={<LineDashboardIcon />}>
        {offer.mileage.unlimited && 'Unlimited mileage limit'}
        {!offer.mileage.unlimited && `${offer.mileage.quantity}${offer.mileage.unit}/${offer.mileage.period} mileage`}
      </BodyTextBlock>}
  </VerticalSpacer>
}

export default CarHireOfferTileVehicleDetailsCondensed
